import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { pushIf } from "./utils/pushIf";
import { initialState } from "./initialState";

const reduceAccountCreationConfirmationNotificationState = createStateReducer(
  initialState,
  {
    [events.confirmAccountCreationSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "confirmAccountCreation",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.confirmAccountCreationFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "confirmAccountCreation",
          flags: pushIf({
            invalidPassword: error.isAccountInvalid.isPasswordInvalid,
            invalidPasswordConfirmation:
              error.isAccountInvalid.isPasswordConfirmationInvalid,
            invalidUsername: error.isAccountInvalid.isUsernameInvalid,
            invalidCompany: error.isAccountInvalid.isCompanyInvalid,
            missingAddress: error.isAccountInvalid.isAddressMissing,
            isPlanzoneNameInvalid: error.isPlanzoneInvalid.isNameInvalid,
            isPlanzoneDomainInvalid: error.isPlanzoneInvalid.isDomainInvalid,
            unExpectedError:
              !error.isAccountInvalid.isPasswordInvalid ||
              !error.isAccountInvalid.isUsernameInvalid ||
              !error.isAccountInvalid.isCompanyInvalid ||
              !error.isAccountInvalid.isAddressMissing ||
              !error.isPlanzoneInvalid.isNameInvalid ||
              !error.isPlanzoneInvalid.isDomainInvalid ||
              !error.isAccountInvalid.isPasswordConfirmationInvalid,
          }),
          args: { failure: "true", message: error.message },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceAccountCreationConfirmationNotificationState };
